export enum 분류1Type {
    제품 = '제품',
    서비스 = '서비스'
}